var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Breadcrumb = function (_a) {
    var collection = _a.collection;
    if (!(collection === null || collection === void 0 ? void 0 : collection.length))
        return null;
    return (_jsx("nav", { children: _jsx("ul", __assign({ className: "breadcrumb" }, { children: collection.map(function (_a, index) {
                var url = _a.url, name = _a.name;
                return (_jsx("li", __assign({ className: "breadcrumb__item" }, { children: _jsxs("a", __assign({ href: url }, { children: [_jsx("span", { dangerouslySetInnerHTML: { __html: name } }, void 0), _jsx("span", __assign({ className: "icon icon-chevron" }, { children: _jsx("svg", __assign({ "data-name": "Layer 1", version: "1.1", viewBox: "0 0 13.25 23.66", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("polygon", { transform: "translate(-27.77,-20.17)", points: "27.77 21.58 29.19 20.17 41.02 32 29.19 43.83 27.77 42.42 38.19 32" }, void 0) }), void 0) }), void 0)] }), void 0) }), "breadcrumb-link-" + index));
            }) }), void 0) }, void 0));
};
export { Breadcrumb };
